import axios from "axios";

import globals from "../../globlas";
import { _sendWithAxios } from "../api";

const BASE = globals.REACT_APP_URL_BASE_API;

const montarQuery = (params) => {
  const query = Object.entries(params)
    .filter(([, valor]) => valor !== undefined && valor !== null && valor !== "")
    .map(([chave, valor]) => `${chave}=${encodeURIComponent(valor)}`);

  return query.length > 0 ? `?${query.join("&")}` : "";
};

// ----------------------------------------------------------------- Concessionárias

export const listarConcessionarias = async (
  page = 1,
  pageSize = 10,
  filtro = "",
  grupoDealerId = "",
  status = ""
) => {
  const query = montarQuery({ filter: filtro, grupoDealerId, status });
  return await _sendWithAxios(
    `${BASE}concessionaria/listagem/${page}/${pageSize}${query}`,
    "GET"
  );
};

/** Concessionárias ativas para o dropdown do cadastro de usuário.
 *  incluirId mantém na lista a concessionária já vinculada, mesmo desativada. */
export const listarConcessionariasParaSelecao = async (incluirId = "") => {
  return await _sendWithAxios(
    `${BASE}concessionaria/selecao${montarQuery({ incluirId })}`,
    "GET"
  );
};

export const detalheConcessionaria = async (id) => {
  return await _sendWithAxios(`${BASE}concessionaria/${id}`, "GET");
};

export const cadastrarConcessionaria = async (dados) => {
  return await _sendWithAxios(`${BASE}concessionaria`, "POST", dados);
};

export const alterarConcessionaria = async (id, dados) => {
  return await _sendWithAxios(`${BASE}concessionaria/${id}`, "PUT", dados);
};

export const alterarStatusConcessionaria = async (id, ativar) => {
  return await _sendWithAxios(
    `${BASE}concessionaria/${id}/status?ativar=${ativar}`,
    "PATCH"
  );
};

export const extrairRelatorioConcessionarias = async (
  filtro = "",
  grupoDealerId = "",
  status = ""
) => {
  const query = montarQuery({ filter: filtro, grupoDealerId, status });
  return await axios.get(`${BASE}concessionaria/relatorio${query}`, {
    responseType: "blob",
  });
};

// ----------------------------------------------------------------- Grupos dealer

export const listarGruposDealer = async (
  page = 1,
  pageSize = 10,
  filtro = "",
  status = ""
) => {
  const query = montarQuery({ filter: filtro, status });
  return await _sendWithAxios(
    `${BASE}grupo-dealer/listagem/${page}/${pageSize}${query}`,
    "GET"
  );
};

export const listarGruposDealerAtivos = async () => {
  return await _sendWithAxios(`${BASE}grupo-dealer/ativos`, "GET");
};

export const detalheGrupoDealer = async (id) => {
  return await _sendWithAxios(`${BASE}grupo-dealer/${id}`, "GET");
};

export const cadastrarGrupoDealer = async (dados) => {
  return await _sendWithAxios(`${BASE}grupo-dealer`, "POST", dados);
};

export const alterarGrupoDealer = async (id, dados) => {
  return await _sendWithAxios(`${BASE}grupo-dealer/${id}`, "PUT", dados);
};

export const alterarStatusGrupoDealer = async (id, ativar) => {
  return await _sendWithAxios(
    `${BASE}grupo-dealer/${id}/status?ativar=${ativar}`,
    "PATCH"
  );
};
